// Extracted from steam .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const STEAM_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.38820001, 0.38820001, 0.38820001],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.43920001, 0.49020001, 0.50590003],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const STEAM_MESH_0: RuneMesh = {
  name: "Steam_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.25700000, 0.43310001, 0.58679992,
    0.20410000, 0.43310001, 0.29859996,
    0.20890000, 0.43309999, 0.16649997,
    0.44430000, 0.43309999, -0.07850003,
    0.39150000, 0.43309996, -0.35230002,
    0.12250000, 0.43309996, -0.53010005,
    0.25220001, 0.43309996, -0.30670002,
    0.25220001, 0.43309999, -0.15060003,
    0.01440000, 0.43309999, 0.11839997,
    0.06240000, 0.43310001, 0.35379997,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.15369999, 0.43310001, 0.54359996,
    -0.21380000, 0.43310001, 0.24809997,
    -0.20420000, 0.43309999, 0.11599997,
    0.02400000, 0.43309999, -0.06890003,
    -0.02160000, 0.43309996, -0.39800003,
    -0.30030000, 0.43309996, -0.53250009,
    -0.17060000, 0.43309996, -0.30910003,
    -0.16329999, 0.43309996, -0.20340003,
    -0.39870000, 0.43309999, 0.12079997,
    -0.39629999, 0.43310001, 0.34899998,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 51, 52, 1, 51, 1, 0,
    1, 53, 54, 1, 54, 2, 3, 2, 55, 3, 55, 4,
    4, 55, 56, 4, 56, 5, 5, 56, 57, 5, 57, 6,
    6, 57, 58, 6, 58, 7, 7, 58, 59, 7, 59, 8,
    8, 59, 60, 8, 60, 9, 9, 60, 61, 9, 61, 10,
    10, 61, 62, 10, 62, 11, 11, 62, 63, 11, 63, 12,
    12, 63, 64, 12, 64, 13, 13, 64, 65, 13, 65, 14,
    14, 65, 66, 14, 66, 15, 15, 66, 67, 15, 67, 16,
    16, 67, 68, 16, 68, 17, 17, 68, 69, 17, 69, 18,
    18, 69, 70, 18, 70, 19, 19, 70, 71, 19, 71, 20,
    20, 71, 72, 20, 72, 21, 21, 72, 73, 21, 73, 22,
    22, 73, 74, 22, 74, 23, 23, 74, 75, 23, 75, 34,
    34, 75, 76, 34, 76, 35, 35, 76, 77, 35, 77, 36,
    36, 77, 78, 36, 78, 47, 47, 78, 79, 47, 79, 48,
    48, 79, 80, 48, 80, 49, 49, 80, 81, 49, 81, 50,
    50, 81, 52, 50, 52, 51, 52, 82, 53, 52, 53, 1,
    53, 83, 84, 53, 84, 54, 2, 54, 85, 2, 85, 55,
    55, 85, 86, 55, 86, 56, 56, 86, 87, 56, 87, 57,
    57, 87, 88, 57, 88, 58, 58, 88, 89, 58, 89, 59,
    59, 89, 90, 59, 90, 60, 60, 90, 91, 60, 91, 61,
    61, 91, 92, 61, 92, 62, 62, 92, 93, 62, 93, 63,
    63, 93, 94, 63, 94, 64, 64, 94, 95, 64, 95, 65,
    65, 95, 96, 65, 96, 66, 66, 96, 97, 66, 97, 67,
    67, 97, 98, 67, 98, 68, 68, 98, 99, 68, 99, 69,
    69, 99, 100, 69, 100, 70, 70, 100, 101, 70, 101, 71,
    71, 101, 102, 71, 102, 72, 72, 102, 103, 72, 103, 73,
    73, 103, 104, 73, 104, 74, 74, 104, 105, 74, 105, 75,
    75, 105, 106, 75, 106, 76, 76, 106, 107, 76, 107, 77,
    77, 107, 108, 77, 108, 78, 78, 108, 109, 78, 109, 79,
    79, 109, 110, 79, 110, 80, 80, 110, 111, 80, 111, 81,
    81, 111, 82, 81, 82, 52, 82, 112, 83, 82, 83, 53,
    83, 113, 114, 83, 114, 84, 54, 84, 115, 54, 115, 85,
    85, 115, 116, 85, 116, 86, 86, 116, 117, 86, 117, 87,
    87, 117, 118, 87, 118, 88, 88, 118, 119, 88, 119, 89,
    89, 119, 120, 89, 120, 90, 90, 120, 121, 90, 121, 91,
    91, 121, 122, 91, 122, 92, 92, 122, 123, 92, 123, 93,
    93, 123, 124, 93, 124, 94, 94, 124, 125, 94, 125, 95,
    95, 125, 126, 95, 126, 96, 96, 126, 127, 96, 127, 97,
    97, 127, 128, 97, 128, 98, 98, 128, 129, 98, 129, 99,
    99, 129, 130, 99, 130, 100, 100, 130, 131, 100, 131, 101,
    101, 131, 132, 101, 132, 102, 102, 132, 133, 102, 133, 103,
    103, 133, 134, 103, 134, 104, 104, 134, 135, 104, 135, 105,
    105, 135, 136, 105, 136, 106, 106, 136, 137, 106, 137, 107,
    107, 137, 138, 107, 138, 108, 108, 138, 139, 108, 139, 109,
    109, 139, 140, 109, 140, 110, 110, 140, 141, 110, 141, 111,
    111, 141, 112, 111, 112, 82, 112, 142, 113, 112, 113, 83,
    113, 143, 144, 113, 144, 114, 84, 114, 145, 84, 145, 115,
    115, 145, 146, 115, 146, 116, 116, 146, 147, 116, 147, 117,
    117, 147, 148, 117, 148, 118, 118, 148, 149, 118, 149, 119,
    119, 149, 150, 119, 150, 120, 120, 150, 151, 120, 151, 121,
    121, 151, 152, 121, 152, 122, 122, 152, 153, 122, 153, 123,
    123, 153, 154, 123, 154, 124, 124, 154, 155, 124, 155, 125,
    125, 155, 156, 125, 156, 126, 126, 156, 157, 126, 157, 127,
    127, 157, 158, 127, 158, 128, 128, 158, 159, 128, 159, 129,
    129, 159, 160, 129, 160, 130, 130, 160, 161, 130, 161, 131,
    131, 161, 162, 131, 162, 132, 132, 162, 163, 132, 163, 133,
    133, 163, 164, 133, 164, 134, 134, 164, 165, 134, 165, 135,
    135, 165, 166, 135, 166, 136, 136, 166, 167, 136, 167, 137,
    137, 167, 168, 137, 168, 138, 138, 168, 169, 138, 169, 139,
    139, 169, 170, 139, 170, 140, 140, 170, 171, 140, 171, 141,
    141, 171, 142, 141, 142, 112, 142, 172, 143, 142, 143, 113,
    143, 173, 174, 143, 174, 144, 114, 144, 175, 114, 175, 145,
    145, 175, 176, 145, 176, 146, 146, 176, 177, 146, 177, 147,
    147, 177, 178, 147, 178, 148, 148, 178, 179, 148, 179, 149,
    149, 179, 180, 149, 180, 150, 150, 180, 181, 150, 181, 151,
    151, 181, 182, 151, 182, 152, 152, 182, 183, 152, 183, 153,
    153, 183, 184, 153, 184, 154, 154, 184, 185, 154, 185, 155,
    155, 185, 186, 155, 186, 156, 156, 186, 187, 156, 187, 157,
    157, 187, 188, 157, 188, 158, 158, 188, 189, 158, 189, 159,
    159, 189, 190, 159, 190, 160, 160, 190, 191, 160, 191, 161,
    161, 191, 192, 161, 192, 162, 162, 192, 193, 162, 193, 163,
    163, 193, 194, 163, 194, 164, 164, 194, 195, 164, 195, 165,
    165, 195, 196, 165, 196, 166, 166, 196, 197, 166, 197, 167,
    167, 197, 198, 167, 198, 168, 168, 198, 199, 168, 199, 169,
    169, 199, 200, 169, 200, 170, 170, 200, 201, 170, 201, 171,
    171, 201, 172, 171, 172, 142, 172, 202, 173, 172, 173, 143,
    173, 205, 207, 173, 207, 174, 144, 174, 208, 144, 208, 175,
    175, 208, 209, 175, 209, 176, 176, 209, 210, 176, 210, 177,
    177, 210, 211, 177, 211, 178, 178, 211, 212, 178, 212, 179,
    179, 212, 213, 179, 213, 180, 180, 213, 214, 180, 214, 181,
    181, 214, 215, 181, 215, 182, 182, 215, 216, 182, 216, 183,
    183, 216, 217, 183, 217, 184, 184, 217, 218, 184, 218, 185,
    185, 218, 219, 185, 219, 186, 186, 219, 220, 186, 220, 187,
    187, 220, 221, 187, 221, 188, 188, 221, 222, 188, 222, 189,
    189, 222, 223, 189, 223, 190, 190, 223, 224, 190, 224, 191,
    191, 224, 225, 191, 225, 192, 192, 225, 226, 192, 226, 193,
    193, 226, 227, 193, 227, 194, 194, 227, 228, 194, 228, 195,
    195, 228, 229, 195, 229, 196, 196, 229, 230, 196, 230, 197,
    197, 230, 231, 197, 231, 198, 198, 231, 232, 198, 232, 199,
    199, 232, 233, 199, 233, 200, 200, 233, 234, 200, 234, 201,
    201, 234, 202, 201, 202, 172, 202, 236, 205, 202, 205, 173,
    203, 237, 239, 203, 239, 206, 174, 207, 241, 174, 241, 208,
    208, 241, 243, 208, 243, 209, 209, 243, 245, 209, 245, 210,
    210, 245, 247, 210, 247, 211, 211, 247, 249, 211, 249, 212,
    212, 249, 251, 212, 251, 213, 213, 251, 253, 213, 253, 214,
    214, 253, 255, 214, 255, 215, 215, 255, 256, 215, 256, 216,
    216, 256, 258, 216, 258, 217, 217, 258, 260, 217, 260, 218,
    218, 260, 262, 218, 262, 219, 219, 262, 264, 219, 264, 220,
    220, 264, 266, 220, 266, 221, 221, 266, 268, 221, 268, 222,
    222, 268, 270, 222, 270, 223, 223, 270, 272, 223, 272, 224,
    224, 272, 274, 224, 274, 225, 225, 274, 276, 225, 276, 226,
    226, 276, 278, 226, 278, 227, 227, 278, 280, 227, 280, 228,
    228, 280, 282, 228, 282, 229, 229, 282, 284, 229, 284, 230,
    230, 284, 286, 230, 286, 231, 231, 286, 288, 231, 288, 232,
    232, 288, 291, 232, 291, 233, 233, 291, 293, 233, 293, 234,
    234, 293, 236, 234, 236, 202, 235, 294, 238, 235, 238, 204,
    237, 295, 298, 237, 298, 239, 206, 239, 300, 206, 300, 240,
    240, 300, 301, 240, 301, 242, 242, 301, 302, 242, 302, 244,
    244, 302, 303, 244, 303, 246, 246, 303, 304, 246, 304, 248,
    248, 304, 305, 248, 305, 250, 250, 305, 306, 250, 306, 252,
    252, 306, 307, 252, 307, 254, 254, 307, 308, 254, 308, 257,
    257, 308, 309, 257, 309, 259, 259, 309, 310, 259, 310, 261,
    261, 310, 311, 261, 311, 263, 263, 311, 312, 263, 312, 265,
    265, 312, 313, 265, 313, 267, 267, 313, 314, 267, 314, 269,
    269, 314, 315, 269, 315, 271, 271, 315, 316, 271, 316, 273,
    273, 316, 317, 273, 317, 275, 275, 317, 318, 275, 318, 277,
    277, 318, 319, 277, 319, 279, 279, 319, 320, 279, 320, 281,
    281, 320, 321, 281, 321, 283, 283, 321, 322, 283, 322, 285,
    285, 322, 323, 285, 323, 287, 287, 323, 324, 287, 324, 289,
    289, 324, 325, 289, 325, 290, 290, 325, 326, 290, 326, 292,
    292, 326, 294, 292, 294, 235, 294, 327, 297, 294, 297, 238,
    296, 329, 330, 296, 330, 299, 239, 298, 331, 239, 331, 300,
    300, 331, 333, 300, 333, 301, 301, 333, 335, 301, 335, 302,
    302, 335, 337, 302, 337, 303, 303, 337, 339, 303, 339, 304,
    304, 339, 341, 304, 341, 305, 305, 341, 343, 305, 343, 306,
    306, 343, 345, 306, 345, 307, 307, 345, 348, 307, 348, 308,
    308, 348, 350, 308, 350, 309, 309, 350, 352, 309, 352, 310,
    310, 352, 354, 310, 354, 311, 311, 354, 356, 311, 356, 312,
    312, 356, 358, 312, 358, 313, 313, 358, 360, 313, 360, 314,
    314, 360, 362, 314, 362, 315, 315, 362, 364, 315, 364, 316,
    316, 364, 366, 316, 366, 317, 317, 366, 368, 317, 368, 318,
    318, 368, 370, 318, 370, 319, 319, 370, 372, 319, 372, 320,
    320, 372, 374, 320, 374, 321, 321, 374, 376, 321, 376, 322,
    322, 376, 378, 322, 378, 323, 323, 378, 380, 323, 380, 324,
    324, 380, 381, 324, 381, 325, 325, 381, 383, 325, 383, 326,
    326, 383, 327, 326, 327, 294, 328, 385, 329, 328, 329, 296,
    329, 386, 387, 329, 387, 330, 299, 330, 388, 299, 388, 332,
    332, 388, 389, 332, 389, 334, 334, 389, 390, 334, 390, 336,
    336, 390, 391, 336, 391, 338, 338, 391, 392, 338, 392, 340,
    340, 392, 393, 340, 393, 342, 342, 393, 394, 342, 394, 344,
    344, 394, 395, 344, 395, 346, 346, 395, 396, 346, 396, 347,
    347, 396, 397, 347, 397, 349, 349, 397, 398, 349, 398, 351,
    351, 398, 399, 351, 399, 353, 353, 399, 400, 353, 400, 355,
    355, 400, 401, 355, 401, 357, 357, 401, 402, 357, 402, 359,
    359, 402, 403, 359, 403, 361, 361, 403, 404, 361, 404, 363,
    363, 404, 405, 363, 405, 365, 365, 405, 406, 365, 406, 367,
    367, 406, 407, 367, 407, 369, 369, 407, 408, 369, 408, 371,
    371, 408, 409, 371, 409, 373, 373, 409, 410, 373, 410, 375,
    375, 410, 411, 375, 411, 377, 377, 411, 412, 377, 412, 379,
    379, 412, 413, 379, 413, 382, 382, 413, 414, 382, 414, 384,
    384, 414, 385, 384, 385, 328, 385, 415, 386, 385, 386, 329,
    386, 416, 417, 386, 417, 387, 330, 387, 418, 330, 418, 388,
    388, 418, 419, 388, 419, 389, 389, 419, 420, 389, 420, 390,
    390, 420, 421, 390, 421, 391, 391, 421, 422, 391, 422, 392,
    392, 422, 423, 392, 423, 393, 393, 423, 424, 393, 424, 394,
    394, 424, 425, 394, 425, 395, 395, 425, 426, 395, 426, 396,
    396, 426, 427, 396, 427, 397, 397, 427, 428, 397, 428, 398,
    398, 428, 429, 398, 429, 399, 399, 429, 430, 399, 430, 400,
    400, 430, 431, 400, 431, 401, 401, 431, 432, 401, 432, 402,
    402, 432, 433, 402, 433, 403, 403, 433, 434, 403, 434, 404,
    404, 434, 435, 404, 435, 405, 405, 435, 436, 405, 436, 406,
    406, 436, 437, 406, 437, 407, 407, 437, 438, 407, 438, 408,
    408, 438, 439, 408, 439, 409, 409, 439, 440, 409, 440, 410,
    410, 440, 441, 410, 441, 411, 411, 441, 442, 411, 442, 412,
    412, 442, 443, 412, 443, 413, 413, 443, 444, 413, 444, 414,
    414, 444, 415, 414, 415, 385, 415, 445, 416, 415, 416, 386,
    416, 446, 447, 416, 447, 417, 387, 417, 448, 387, 448, 418,
    418, 448, 449, 418, 449, 419, 419, 449, 450, 419, 450, 420,
    420, 450, 451, 420, 451, 421, 421, 451, 452, 421, 452, 422,
    422, 452, 453, 422, 453, 423, 423, 453, 454, 423, 454, 424,
    424, 454, 455, 424, 455, 425, 425, 455, 456, 425, 456, 426,
    426, 456, 457, 426, 457, 427, 427, 457, 458, 427, 458, 428,
    428, 458, 459, 428, 459, 429, 429, 459, 460, 429, 460, 430,
    430, 460, 461, 430, 461, 431, 431, 461, 462, 431, 462, 432,
    432, 462, 463, 432, 463, 433, 433, 463, 464, 433, 464, 434,
    434, 464, 465, 434, 465, 435, 435, 465, 466, 435, 466, 436,
    436, 466, 467, 436, 467, 437, 437, 467, 468, 437, 468, 438,
    438, 468, 469, 438, 469, 439, 439, 469, 470, 439, 470, 440,
    440, 470, 471, 440, 471, 441, 441, 471, 472, 441, 472, 442,
    442, 472, 473, 442, 473, 443, 443, 473, 474, 443, 474, 444,
    444, 474, 445, 444, 445, 415, 445, 475, 446, 445, 446, 416,
    446, 476, 477, 446, 477, 447, 417, 447, 478, 417, 478, 448,
    448, 478, 479, 448, 479, 449, 449, 479, 480, 449, 480, 450,
    450, 480, 481, 450, 481, 451, 451, 481, 482, 451, 482, 452,
    452, 482, 483, 452, 483, 453, 453, 483, 484, 453, 484, 454,
    454, 484, 485, 454, 485, 455, 455, 485, 486, 455, 486, 456,
    456, 486, 487, 456, 487, 457, 457, 487, 488, 457, 488, 458,
    458, 488, 489, 458, 489, 459, 459, 489, 490, 459, 490, 460,
    460, 490, 491, 460, 491, 461, 461, 491, 492, 461, 492, 462,
    462, 492, 493, 462, 493, 463, 463, 493, 494, 463, 494, 464,
    464, 494, 495, 464, 495, 465, 465, 495, 496, 465, 496, 466,
    466, 496, 497, 466, 497, 467, 467, 497, 498, 467, 498, 468,
    468, 498, 499, 468, 499, 469, 469, 499, 500, 469, 500, 470,
    470, 500, 501, 470, 501, 471, 471, 501, 502, 471, 502, 472,
    472, 502, 503, 472, 503, 473, 473, 503, 504, 473, 504, 474,
    474, 504, 475, 474, 475, 445, 475, 505, 476, 475, 476, 446,
    476, 506, 507, 476, 507, 477, 447, 477, 508, 447, 508, 478,
    478, 508, 509, 478, 509, 479, 479, 509, 510, 479, 510, 480,
    480, 510, 511, 480, 511, 481, 481, 511, 512, 481, 512, 482,
    482, 512, 513, 482, 513, 483, 483, 513, 514, 483, 514, 484,
    484, 514, 515, 484, 515, 485, 485, 515, 516, 485, 516, 486,
    486, 516, 517, 486, 517, 487, 487, 517, 518, 487, 518, 488,
    488, 518, 519, 488, 519, 489, 489, 519, 520, 489, 520, 490,
    490, 520, 521, 490, 521, 491, 491, 521, 522, 491, 522, 492,
    492, 522, 523, 492, 523, 493, 493, 523, 524, 493, 524, 494,
    494, 524, 525, 494, 525, 495, 495, 525, 526, 495, 526, 496,
    496, 526, 527, 496, 527, 497, 497, 527, 528, 497, 528, 498,
    498, 528, 529, 498, 529, 499, 499, 529, 530, 499, 530, 500,
    500, 530, 531, 500, 531, 501, 501, 531, 532, 501, 532, 502,
    502, 532, 533, 502, 533, 503, 503, 533, 534, 503, 534, 504,
    504, 534, 505, 504, 505, 475, 505, 535, 506, 505, 506, 476,
    506, 536, 537, 506, 537, 507, 477, 507, 538, 477, 538, 508,
    508, 538, 539, 508, 539, 509, 509, 539, 540, 509, 540, 510,
    510, 540, 541, 510, 541, 511, 511, 541, 542, 511, 542, 512,
    512, 542, 543, 512, 543, 513, 513, 543, 544, 513, 544, 514,
    514, 544, 545, 514, 545, 515, 515, 545, 546, 515, 546, 516,
    516, 546, 547, 516, 547, 517, 517, 547, 548, 517, 548, 518,
    518, 548, 549, 518, 549, 519, 519, 549, 550, 519, 550, 520,
    520, 550, 551, 520, 551, 521, 521, 551, 552, 521, 552, 522,
    522, 552, 553, 522, 553, 523, 523, 553, 554, 523, 554, 524,
    524, 554, 555, 524, 555, 525, 525, 555, 556, 525, 556, 526,
    526, 556, 557, 526, 557, 527, 527, 557, 558, 527, 558, 528,
    528, 558, 559, 528, 559, 529, 529, 559, 560, 529, 560, 530,
    530, 560, 561, 530, 561, 531, 531, 561, 562, 531, 562, 532,
    532, 562, 563, 532, 563, 533, 533, 563, 564, 533, 564, 534,
    534, 564, 535, 534, 535, 505, 535, 565, 536, 535, 536, 506,
    536, 566, 537, 507, 537, 567, 507, 567, 538, 538, 567, 568,
    538, 568, 539, 539, 568, 569, 539, 569, 540, 540, 569, 570,
    540, 570, 541, 541, 570, 571, 541, 571, 542, 542, 571, 572,
    542, 572, 543, 543, 572, 573, 543, 573, 544, 544, 573, 574,
    544, 574, 545, 545, 574, 575, 545, 575, 546, 546, 575, 576,
    546, 576, 547, 547, 576, 577, 547, 577, 548, 548, 577, 578,
    548, 578, 549, 549, 578, 579, 549, 579, 550, 550, 579, 580,
    550, 580, 551, 551, 580, 581, 551, 581, 552, 552, 581, 582,
    552, 582, 553, 553, 582, 583, 553, 583, 554, 554, 583, 584,
    554, 584, 555, 555, 584, 585, 555, 585, 556, 556, 585, 586,
    556, 586, 557, 557, 586, 587, 557, 587, 558, 558, 587, 588,
    558, 588, 559, 559, 588, 589, 559, 589, 560, 560, 589, 590,
    560, 590, 561, 561, 590, 591, 561, 591, 562, 562, 591, 592,
    562, 592, 563, 563, 592, 593, 563, 593, 564, 564, 593, 565,
    564, 565, 535, 565, 566, 536, 537, 566, 567, 567, 566, 568,
    568, 566, 569, 569, 566, 570, 570, 566, 571, 571, 566, 572,
    572, 566, 573, 573, 566, 574, 574, 566, 575, 575, 566, 576,
    576, 566, 577, 577, 566, 578, 578, 566, 579, 579, 566, 580,
    580, 566, 581, 581, 566, 582, 582, 566, 583, 583, 566, 584,
    584, 566, 585, 585, 566, 586, 586, 566, 587, 587, 566, 588,
    588, 566, 589, 589, 566, 590, 590, 566, 591, 591, 566, 592,
    592, 566, 593, 593, 566, 565, 22, 23, 24, 24, 25, 26,
    26, 19, 20, 20, 21, 22, 22, 24, 26, 26, 20, 22,
    36, 47, 48, 48, 49, 50, 50, 51, 0, 0, 3, 4,
    4, 44, 45, 46, 37, 36, 4, 45, 46, 50, 0, 4,
    36, 48, 50, 4, 46, 36, 50, 4, 36, 42, 43, 44,
    44, 4, 5, 5, 6, 7, 7, 8, 9, 9, 10, 11,
    11, 12, 13, 13, 14, 15, 15, 16, 17, 17, 18, 19,
    19, 26, 27, 19, 27, 28, 15, 17, 19, 11, 13, 15,
    7, 9, 11, 44, 5, 7, 42, 44, 7, 11, 15, 19,
    11, 19, 28, 42, 7, 11, 41, 42, 11, 11, 28, 29,
    29, 30, 31, 29, 31, 32, 41, 11, 29, 38, 39, 40,
    40, 41, 29, 40, 29, 32, 37, 38, 40, 35, 36, 37,
    23, 34, 35, 33, 24, 23, 37, 40, 32, 33, 23, 35,
    37, 32, 33, 33, 35, 37,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.02099966, 0.99768385, 0.06469895,
    -0.02310028, -0.99751226, -0.06660082,
    -0.75680386, 0.64850336, 0.08180042,
    -0.70646748, 0.66376946, -0.24558870,
    -0.86021416, -0.47260781, -0.19150315,
    -0.73020850, -0.38880452, 0.56180655,
    0.54258310, -0.26449176, 0.79727517,
    0.78557066, 0.55067943, -0.28218948,
    0.73038022, 0.64698248, 0.21899406,
    0.85851902, -0.48561075, 0.16470365,
    0.78598592, -0.44159208, -0.43269224,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01900001, 0.99810071, 0.05860004,
    -0.04769899, -0.99317890, -0.10639774,
    -0.75798979, 0.64739129, 0.07959892,
    -0.68272487, 0.66332416, -0.30641117,
    -0.84072317, -0.46951298, -0.26970745,
    -0.70971105, -0.36260565, 0.60400942,
    0.58418045, -0.27539076, 0.76347438,
    0.77396511, 0.56037473, -0.29488670,
    0.75401713, 0.63871450, 0.15330349,
    0.82626205, -0.52387591, 0.20699048,
    0.79347881, -0.38408972, -0.47208736,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
  ]),
  materialIndex: 0,
};

const STEAM_MESH_1: RuneMesh = {
  name: "Steam_Rune_primitive1",
  positions: new Float32Array([
    0.25700000, 0.43310001, 0.58679992,
    0.20410000, 0.43310001, 0.29859996,
    0.20890000, 0.43309999, 0.16649997,
    0.44430000, 0.43309999, -0.07850003,
    0.39150000, 0.43309996, -0.35230002,
    0.12250000, 0.43309996, -0.53010005,
    0.25220001, 0.43309996, -0.30670002,
    0.25220001, 0.43309999, -0.15060003,
    0.01440000, 0.43309999, 0.11839997,
    0.06240000, 0.43310001, 0.35379997,
    -0.15369999, 0.43310001, 0.54359996,
    -0.21380000, 0.43310001, 0.24809997,
    -0.20420000, 0.43309999, 0.11599997,
    0.02400000, 0.43309999, -0.06890003,
    -0.02160000, 0.43309996, -0.39800003,
    -0.30030000, 0.43309996, -0.53250009,
    -0.17060000, 0.43309996, -0.30910003,
    -0.17060000, 0.43309996, -0.30910003,
    -0.16329999, 0.43309996, -0.20340003,
    -0.39870000, 0.43309999, 0.12079997,
    -0.39629999, 0.43310001, 0.34899998,
    -0.28470001, 0.35449997, -0.45190004,
    -0.17510000, 0.35449997, -0.26320004,
    -0.16900000, 0.35450000, -0.17390002,
    -0.04930000, 0.35449997, -0.33830002,
    -0.01080000, 0.35450000, -0.06030003,
    -0.20350000, 0.35450000, 0.09589997,
    -0.21160001, 0.35450003, 0.20749997,
    -0.16090000, 0.35450003, 0.45709997,
    -0.36579999, 0.35450003, 0.29269996,
    -0.36790001, 0.35450000, 0.09999997,
    0.13779999, 0.35449997, -0.44610003,
    0.24730000, 0.35449997, -0.25740004,
    0.24730000, 0.35450000, -0.12560003,
    0.36500001, 0.35449997, -0.29600003,
    0.40959999, 0.35450000, -0.06470003,
    0.21080001, 0.35450000, 0.14229997,
    0.20680000, 0.35450003, 0.25389996,
    0.25139999, 0.35450003, 0.49729997,
    0.08700000, 0.35450003, 0.30049998,
    0.04650000, 0.35450000, 0.10169997,
  ]),
  indices: new Uint16Array([
    4, 3, 35, 4, 35, 34, 17, 15, 21, 17, 21, 22,
    18, 16, 22, 18, 22, 23, 15, 14, 24, 15, 24, 21,
    19, 18, 23, 19, 23, 30, 20, 19, 30, 20, 30, 29,
    10, 20, 29, 10, 29, 28, 11, 10, 28, 11, 28, 27,
    12, 11, 27, 12, 27, 26, 13, 12, 26, 13, 26, 25,
    14, 13, 25, 14, 25, 24, 6, 5, 31, 6, 31, 32,
    7, 6, 32, 7, 32, 33, 5, 4, 34, 5, 34, 31,
    8, 7, 33, 8, 33, 40, 9, 8, 40, 9, 40, 39,
    0, 9, 39, 0, 39, 38, 1, 0, 38, 1, 38, 37,
    2, 1, 37, 2, 37, 36, 3, 2, 36, 3, 36, 35,
  ]),
  normals: new Float32Array([
    -0.02310028, -0.99751226, -0.06660082,
    -0.75680386, 0.64850336, 0.08180042,
    -0.70646748, 0.66376946, -0.24558870,
    -0.86021416, -0.47260781, -0.19150315,
    -0.73020850, -0.38880452, 0.56180655,
    0.54259745, -0.26439877, 0.79729625,
    0.78557066, 0.55067943, -0.28218948,
    0.73038022, 0.64698248, 0.21899406,
    0.85851902, -0.48561075, 0.16470365,
    0.78602061, -0.44151159, -0.43271135,
    -0.04769899, -0.99317890, -0.10639774,
    -0.75798979, 0.64739129, 0.07959892,
    -0.68272487, 0.66332416, -0.30641117,
    -0.84079196, -0.46939553, -0.26969744,
    -0.70971105, -0.36260565, 0.60400942,
    0.58418045, -0.27539076, 0.76347438,
    0.77398791, 0.56039126, -0.29479543,
    0.77396511, 0.56037473, -0.29488670,
    0.75401713, 0.63871450, 0.15330349,
    0.82623032, -0.52391919, 0.20700760,
    0.79350927, -0.38400449, -0.47210548,
    0.72281980, 0.66951828, 0.17110468,
    0.67138629, -0.72518520, -0.15279688,
    0.74000032, -0.61310024, 0.27660013,
    -0.49860869, 0.82251431, 0.27360479,
    -0.60820695, 0.73250839, -0.30580349,
    -0.69998179, -0.58078490, -0.41558920,
    -0.72190266, -0.69180261, 0.01630006,
    -0.56858595, 0.74318160, -0.35269127,
    0.55549659, 0.81049510, -0.18579887,
    0.62791150, 0.73601346, 0.25300461,
    0.70297481, 0.68207557, 0.20149277,
    0.69082514, -0.71292595, -0.12040438,
    0.72300363, -0.60600310, 0.33170167,
    -0.49902396, 0.82503960, 0.26511272,
    -0.62770821, 0.73710968, -0.25030327,
    -0.72198099, -0.59058447, -0.36049053,
    -0.71090246, -0.70280243, 0.02620009,
    -0.50209497, 0.76659230, -0.40029599,
    0.52582281, 0.82423573, -0.21010911,
    0.64306541, 0.72786082, 0.23808718,
  ]),
  materialIndex: 1,
};

const STEAM_MESH_2: RuneMesh = {
  name: "Steam_Rune_primitive2",
  positions: new Float32Array([
    -0.28470001, 0.35449997, -0.45190004,
    -0.17510000, 0.35449997, -0.26320004,
    -0.16900000, 0.35450000, -0.17390002,
    -0.04930000, 0.35449997, -0.33830002,
    -0.01080000, 0.35450000, -0.06030003,
    -0.20350000, 0.35450000, 0.09589997,
    -0.21160001, 0.35450003, 0.20749997,
    -0.16090000, 0.35450003, 0.45709997,
    -0.36579999, 0.35450003, 0.29269996,
    -0.36790001, 0.35450000, 0.09999997,
    0.13779999, 0.35449997, -0.44610003,
    0.24730000, 0.35449997, -0.25740004,
    0.24730000, 0.35450000, -0.12560003,
    0.36500001, 0.35449997, -0.29600003,
    0.40959999, 0.35450000, -0.06470003,
    0.21080001, 0.35450000, 0.14229997,
    0.20680000, 0.35450003, 0.25389996,
    0.25139999, 0.35450003, 0.49729997,
    0.08700000, 0.35450003, 0.30049998,
    0.04650000, 0.35450000, 0.10169997,
  ]),
  indices: new Uint16Array([
    1, 0, 3, 3, 4, 5, 6, 7, 8, 5, 6, 8,
    8, 9, 2, 2, 1, 3, 3, 5, 8, 3, 8, 2,
    11, 10, 13, 13, 14, 15, 16, 17, 18, 15, 16, 18,
    18, 19, 12, 12, 11, 13, 13, 15, 18, 13, 18, 12,
  ]),
  normals: new Float32Array([
    0.72281980, 0.66951828, 0.17110468,
    0.67138629, -0.72518520, -0.15279688,
    0.74000032, -0.61310024, 0.27660013,
    -0.49860869, 0.82251431, 0.27360479,
    -0.60820695, 0.73250839, -0.30580349,
    -0.69998179, -0.58078490, -0.41558920,
    -0.72190266, -0.69180261, 0.01630006,
    -0.56858595, 0.74318160, -0.35269127,
    0.55549659, 0.81049510, -0.18579887,
    0.62791150, 0.73601346, 0.25300461,
    0.70297481, 0.68207557, 0.20149277,
    0.69077590, -0.71297511, -0.12039580,
    0.72300363, -0.60600310, 0.33170167,
    -0.49902396, 0.82503960, 0.26511272,
    -0.62770821, 0.73710968, -0.25030327,
    -0.72198099, -0.59058447, -0.36049053,
    -0.71090246, -0.70280243, 0.02620009,
    -0.50209497, 0.76659230, -0.40029599,
    0.52582281, 0.82423573, -0.21010911,
    0.64306541, 0.72786082, 0.23808718,
  ]),
  materialIndex: 2,
};

export const STEAM_MESHES: RuneMesh[] = [
  STEAM_MESH_0,
  STEAM_MESH_1,
  STEAM_MESH_2,
];
